module.exports = __webpack_public_path__ + "static/media/feature1.6ca3471f.jpeg";